import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/client'

import { client } from './apollo'
import Wrapper from './Wrapper'
import { SelectionProvider } from './context/SelectionContext'
import { TrackProvider } from './context/TrackContext'
import * as serviceWorker from './serviceWorker'
// import { register as registerServiceWorker } from './serviceWorker'

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <SelectionProvider>
        <TrackProvider>
          <Wrapper />
        </TrackProvider>
      </SelectionProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorker.unregister()
